import { apiService } from '../../shared/services/apiService';

const getSupplements = async () => {
  const resp = await apiService('api/supplements/active-calendar');
  return resp.data;
};

export const supplementsService = { getSupplements };
